export function isFinanceOnlyUser(userData) {
  return userData?.role === "accountant" || userData?.companyRole === "accountant";
}

export function canOpenFinanceRoute(pathname) {
  return ["/finance", "/transactions", "/rapid-record/lite", "/payroll",
    "/auth", "/privacy-policy", "/terms-of-service", "/account-deletion"].includes(pathname);
}
